import { makeStyles } from "@material-ui/core/styles";
import { CardActionArea, Typography } from "@material-ui/core";
import { AiTwotoneSetting } from "react-icons/ai";
import { navigate } from "@reach/router";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  container: {
    border: `0.5px solid ${theme.palette.primary.main}`,
    padding: theme.spacing(1.5),
    borderRadius: "4px",
    display: "flex",
    justifyContent: "space-between",
  },
  note: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },
  subText: {
    color: theme.palette.grey[600],
    fontSize: "10px",
  },
  settingIcon: {
    height: "100%",
    fontSize: "20px",
    color: theme.palette.primary.main,
  },
}));

function Note({ noteText, subText }) {
  const classes = useStyles();

  return (
    <>
      <div className={classes.root}>
        <CardActionArea className={classes.container} onClick={() => navigate("/privacy")}>
          <div>
            <Typography variant="body2">
              <span className={classes.note}>Hinweis: </span>
              {noteText}
              <br />
            </Typography>
            <Typography variant="body2" className={classes.subText}>
              {subText}
            </Typography>
          </div>
          <AiTwotoneSetting className={classes.settingIcon} />
        </CardActionArea>
      </div>
    </>
  );
}

export default Note;
